import { render } from "./PrivacyPolicyPage.vue?vue&type=template&id=9d024da0&scoped=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=9d024da0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d024da0"]])

export default __exports__